import { render, staticRenderFns } from "./AddSubFee.vue?vue&type=template&id=08bbce4d&scoped=true&"
import script from "./AddSubFee.vue?vue&type=script&lang=js&"
export * from "./AddSubFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbce4d",
  null
  
)

export default component.exports